import * as moment from "moment";
import MenuEntryType from "app/domain/menu/MenuEntryType";
import MenuConfigFormSelectIconSize from "../routes/app/routes/menu/routes/list/components/forms/menu-config/MenuConfigFormSelectIconSize";
import i18n from "./I18n";
import 'babel-polyfill';

let Config = {
  App: {
    title: "AZA E-Commerce panel",
    short_title: "AZA Panel",
    logo: "assets/images/logo.png",
    loader: "assets/images/loader.gif",
    favicon: "assets/images/favicon.png",
    url: '',
    panelUrl: false,
    isMasterPanel: false,
  },
  Api: null, // must be specified in local configuration
  Locale: {
    enableMultiLanguage: true,
    default: 'pl_PL',
    currency: 'zł',
    dateFormat: "D.m.YYYY",
    dateTimeFormat: "DD.MM.YYYY HH:mm:ss"
  },
  Preferences: {
    layoutBoxed: false,                             // true, false
    navCollapsed: false,                            // true, false
    navBehind: false,                               // true, false
    fixedHeader: true,                              // true, false
    sidebarWidth: 'middle',                         // small, middle, large
    colorOption: '14',                              // String: 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
    theme: 'light',                                 // light, gray, dark
    enableRandomData: true
  },

  bannerKinds: {
    105: {
      name: i18n.t("Strona główna"),
      children: {
        1: {name: i18n.t('Kobiety'), url: '/kobiety-home'},
        2: {name: i18n.t('Męzczyzni'), url: '/mezczyzni-home'},
        3: {name: i18n.t('Dzieci'), url: '/dzieci-home'}
      }
    }
    // 106: {
    //   name: "Listing",
    //   children: {
    //     1: {name: 'Kobiety', url: '/kobiety-home'},
    //     2: {name: 'Męzczyzni', url: '/mezczyzni-home'},
    //     3: {name: 'Dzieci', url: '/dzieci-home'}
    //   }W
    // },
  },

  productTypes: {
    0: {name: i18n.t("Ubrania")},
    1: {name: i18n.t("Obuwie")},
    2: {name: i18n.t("Torebki")},
    3: {name: i18n.t("Akcesoria")},
    4: {name: i18n.t("Biżuteria")},
    5: {name: i18n.t("Stroje kąpielowe")}
  },

  menuTypes: {
    top: {
      id: 0,
      name: i18n.t("Top menu"),
      url: "#",
      isWeb: true,
      children: {
        unisex: {id: 0, name: i18n.t('Unisex')},
        kobiety: {id: 1, name: i18n.t('Kobiety')},
        mezczyzni: {id: 2, name: i18n.t('Mężczyźni')},
        dzieci: {id: 3, name: i18n.t('Dzieci')},
      }
    },
    mobilne: {
      id: 1,
      name: i18n.t("Menu mobilne"),
      url: "#",
      isWeb: true,
      children: {
        unisex: {id: 0, name: i18n.t('Unisex')},
        kobiety: {id: 1, name: i18n.t('Kobiety')},
        mezczyzni: {id: 2, name: i18n.t('Mężczyźni')},
        dzieci: {id: 3, name: i18n.t('Dzieci')},
      }
    },
    stopka: {
      id: 2,
      name: i18n.t("Menu w stópce"),
      url: "#",
      isWeb: true,
      children: {
        unisex: {id: 0, name: i18n.t('Unisex')},
        kobiety: {id: 1, name: i18n.t('Kobiety')},
        mezczyzni: {id: 2, name: i18n.t('Mężczyźni')},
        dzieci: {id: 3, name: i18n.t('Dzieci')},
      }
    },
    mobile_app: {
      id: 3,
      url: "#",
      name: i18n.t("Menu mobilne APP"),
      children: {
        unisex: {id: 0, name: i18n.t("Unisex")}
      }
    },
    mobile_app_v4: {
      id: 4,
      url: "#",
      name: i18n.t("Menu mobilne APP (v4)"),
      children: {
        unisex: {id: 0, name: i18n.t("Unisex")}
      }
    }
  },

  menuEntryTypes: {
    0: new MenuEntryType('link', i18n.t('Link')),
    1: new MenuEntryType('header', i18n.t('Nagłówek')),
    2: new MenuEntryType('divider', i18n.t('Separator')),
    3: new MenuEntryType('column', i18n.t('Kolumna')),
    4: new MenuEntryType('submenu', i18n.t('Podmenu')),
    5: new MenuEntryType('main', i18n.t('Główny wpis'), undefined, undefined, false),
    6: new MenuEntryType('banner', i18n.t('Baner / zdjęcie')),
    7: new MenuEntryType('slider', i18n.t('Slider'), [3], ['sliderElement'], true, null, MenuConfigFormSelectIconSize),
    8: new MenuEntryType('sliderElement', i18n.t('Slider - element'), [3], [], true, ['slider']),
    9: new MenuEntryType('grid', i18n.t('Grid'), [3], ['gridElement'], true, null, MenuConfigFormSelectIconSize),
    10: new MenuEntryType('gridElement', i18n.t('Grid - element'), [3], [], true, ['grid']),
  },

  seasons: {
    "Całoroczny": {label: "Całoroczny"},
    "Wiosna": {label: "Wiosna"},
    "Lato": {label: "Lato"},
    "Jesień": {label: "Jesień"},
    "Zima": {label: "Zima"},
  },
};

export const loadMainConfiguration = async () => {
  let localConfig = null;
  try {
    localConfig = await fetch('config.json').then(res => res.json());
  } catch (ex) {
    console.error(ex);
    throw new Error("Failed to load local configuration!");
  }

  if (localConfig) {
    Config = $.extend(true, Config, localConfig);

    if (localConfig.bannerKinds) {
      Config.bannerKinds = localConfig.bannerKinds;
    }
  }

  moment.locale(Config.Locale.default);

  return Config;
};

export default Config;



// WEBPACK FOOTER //
// ./constants/Configuration.js